export function getDecimalPlaces(step: number): number {
  const stepString = step.toString()
  const decimalIndex = stepString.indexOf(".")

  if (decimalIndex === -1) {
    return 0
  }

  return stepString.length - decimalIndex - 1
}
